import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import ar from './locales/ar.json';

const messages = { en, ar };


Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // default
  fallbackLocale: 'en',
  messages,
});

export default i18n;
